import { Component, inject, Input } from "@angular/core";

import { GlobalService } from "@shared/services";
import { SidebarComponent } from "@core/components";
import { fadeInOutAnimation } from "@shared/animations";

@Component({
  selector: "app-page",
  standalone: true,
  imports: [SidebarComponent],
  templateUrl: "./page.component.html",
  styleUrl: "./page.component.scss",
  animations: [fadeInOutAnimation],
})
export class PageComponent {
  globalService = inject(GlobalService);

  @Input() pageTitle: string = "";
  sidebarVisible: boolean = false;

  getContentHeight(): string {
    return `calc(100vh - (${this.globalService.navbarHeight()}px + 50px))`;
  }

  openSidebar(): void {
    this.sidebarVisible = true;
    this.globalService.checkforUnsavedData();
  }
}
